<div class="work-popup modal-dialog">

  <div class="modal-content">
    <form [formGroup]="editForm" method="post" (ngSubmit)="edit()" class="py-3 px-sm-4">
      <div class="size-fixed width-100 d-flex align-items-center justify-content-center">
        <img [src]="contentIcon" class="content-icon-styles" alt="">
      </div>
      <div class="flex-fill mt-30px">
        @if (!isDocument()) {
          <app-filled-form-field
            formControlName="placeholder"
            [label]="isContact() ? data.contentName : 'Profile Link'">
          </app-filled-form-field>
        } @else {
          <input
            #documentUploadInput
            hidden
            tabindex="-1"
            (input)="onFileSelected($event)"
            accept="application/pdf"
            type="file"
            class="form-control text-size"
          />
          <label class="document-input-label"
            [class]="!selectedFileName && !hasDocumentURL ? 'cursor-pointer' : ''"
            [ngClass]="{'disabled': hasDocumentURL, 'has-error': showError || fileSizeExceeded}">
            <div (click)="clickChooseFile(documentUploadInput)" class="document-choose-file">Choose File</div>
            <div (click)="clickChooseFile(documentUploadInput)" class="document-file-name">{{ documentName }}</div>
            @if(selectedFileName) {
              <mat-icon class="document-clear-icon" (click)="clearDocument()">close</mat-icon>
            }
          </label>
        }

        @if (editUserCardContentControl['placeholder'].invalid && editUserCardContentControl['placeholder'].touched && !isDocument()) {
          <div class="validation" [style.margin-top]="isDocument() ? '' : '-20px'">
            @if (editUserCardContentControl['placeholder'].errors?.['required'] || editUserCardContentControl['placeholder'].errors?.['whitespace']) {
              <small>Enter
                <small
                  class="inner-small"
                  [textContent]="isContact() ? data.contentName.toLowerCase() :  'profile link'"></small>
              </small>
            }
          </div>
        }

        @if (isDocument()) {
          @if (fileSizeExceeded) {
            <div class="validation">
              <small *ngIf="fileSizeExceeded">{{ 'error_messages_user_card.file_size_error' | translate }}</small>
            </div>
          }
        }
      </div>

      @if (isDocument()) {
        <div class="mr-2 mt-2 flex-fill">
           <app-filled-form-field
             formControlName="placeholder"
             [label]="'URL'"
             [errorMessage]="'Please upload a file or provide a link'"
             [isControlInvalid]="showError && isBothDocumentFieldsInvalid()"
           >
           </app-filled-form-field>
        </div>
      }

      <div class="mr-2 flex-fill">
        <app-filled-form-field
          formControlName="linkTitle"
          [label]="'Link Title'"
        >
        </app-filled-form-field>
      </div>

      @if (editUserCardContentControl['linkTitle'].invalid && editUserCardContentControl['linkTitle'].touched) {
        <div class="validation validation-direction">
          @if (editUserCardContentControl['linkTitle'].errors?.['whitespace']) {
            <small>Enter link title</small>
          } @else if (editUserCardContentControl['linkTitle'].errors?.['maxlength'] && editUserCardContentControl['linkTitle'].touched) {
            <small>{{ 'error_messages_user_card.linkTitleError' | translate }}</small>
          }
        </div>
      }

      <div class="mt-30px d-flex justify-content-center buttons-style flex-direction-row">
        <button type="submit"
                class="filled-button short-button width-100 mr-10px d-flex align-items-center justify-content-center"
                [disabled]="editForm.invalid">
          {{ 'user_card.save' | translate }}
        </button>
        <button type="button"
                class="outlined-button short-button width-100 ml-10px d-flex align-items-center justify-content-center"
                (click)="closeDialog()">
          {{ 'user_card.cancel' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
